export const WITHHOLDING_TAX = 0.15;
export const TYMBE_ID = 113;
export const lengthOfVacationShift = 4;

// wednesday, thursday, friday
export const vacationDays = [3, 4, 5];

export const AGENCY_ALLOWED_CZ_ISCO_CODES = [
  524, 721, 722, 723, 751, 753, 812, 814, 815, 816, 821, 833, 834,
];

